import React, { Component } from 'react';
import Switch from '../Part_Sample/Switch';
import { getFanstepIcon, isEmpty } from '../Common/Common';

export default class Command_Fanstep extends Component {
	constructor(props) {
		super(props);

		this.state = {
			is_enabled: this.props.action_details.fanstep != null ? true : false,
			fanstep: this.props.action_details.fanstep != null ? this.props.action_details.fanstep : 'L'
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		let is_enabled = false;
		if (nextProps.action_details.fanstep != null) is_enabled = true;
		if (is_enabled != nextState.is_enabled) {
			this.setState({
				is_enabled: is_enabled,
			})
		}

		let fanstep = nextProps.action_details.fanstep != null ? nextProps.action_details.fanstep : 'L';

		if (fanstep != nextState.fanstep) {
			this.setState({
				fanstep: fanstep
			})
		}
		return true;
	}

	handleToggleEnable = () => {
		let is_enabled = !(this.props.action_details.fanstep != null ? true : false)
		this.setState({ is_enabled: is_enabled })
		if (is_enabled) {
			this.props.handleChangeFanstep(this.state.fanstep);
		} else {
			this.props.handleChangeFanstep(null);
		}
	}

	handleOnClick = () => {
		if (this.state.is_enabled) {
			let step = this.state.fanstep;
			let steps = 3;
			if (!isEmpty(this.props.point_info)) {
				steps = this.props.point_info.fanstep_cap.S != null ? this.props.point_info.fanstep_cap.S : 3;
			}

			if (step == 'L') {
				if (steps == 2) step = 'H';
				else if (steps == 3) step = 'M';
				else step = 'LM';
			} else if (step == 'LM') {
				step = 'M';
			} else if (step == 'M') {
				if (steps == 3) step = 'H';
				else step = 'MH';
			} else if (step == 'MH') {
				step = 'H';
			} else if (step == 'H') {
				step = 'A';
			} else if (step == 'A') {
				step = 'L';
			}

			this.setState({ fanstep: step });

			this.props.handleChangeFanstep(step);
		} else {
			window.app.showToast(this.props.receiver.getString('no_enabled'), 3000);
			return;
		}
	}

	render() {
		let style = {
			textAlign: 'left',
			width: this.props.width - 40,
			marginTop: 10,
			marginLeft: 10,
			background: 'white',
			padding: 10,
			borderRadius: 20,
		}

		let steps = 3;
		if (!isEmpty(this.props.point_info)) {
			steps = this.props.point_info.fanstep_cap.S != null ? this.props.point_info.fanstep_cap.S : 3;
		}

		let icon = getFanstepIcon(steps, this.state.fanstep);

		if (steps == 0) {
			return null
		} else {
			return (
				<div style={style}>
					<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
						<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleEnable} />
					</div>
					<div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: 2, marginLeft: 5, width: this.props.width - 120 }}>
						<span>{this.props.receiver.getString('fanstep')}</span>
					</div>
					<div style={{ display: 'inline-block', verticalAlign: 'top' }} onClick={this.handleOnClick}>
						<img src={icon} style={{ width: 25, }} />
					</div>
				</div>
			)
		}
	}
}